import React from 'react';
import {
  ToastContainer as BasicToastContainer,
  ToastContainerProps,
  Zoom,
} from 'react-toastify';
import clsx from 'clsx';

import CloseIcon from 'app/assets/svgs/CloseIcon';

import 'react-toastify/dist/ReactToastify.min.css';

const customDefaultConfig: ToastContainerProps = {
  position: 'top-center',
  hideProgressBar: true,
  closeOnClick: false,
  icon: false,
  closeButton: ({ closeToast }) => (
    <button className="mr-4" onClick={closeToast}>
      <CloseIcon />
    </button>
  ),
  autoClose: 10000,
  transition: Zoom,
};

const contextClass = {
  success: 'bg-toast-success text-white shadow-toast-success/20',
  error: 'bg-toast-error text-white shadow-toast-error/20',
};

const ToastContainer = (props: ToastContainerProps) => {
  return (
    <BasicToastContainer
      toastClassName={options =>
        clsx(
          contextClass[options?.type!],
          options?.defaultClassName,
          'font font-semibold text-sm min-h-[auto] p-0 shadow-toast w-full max-w-[20rem] mx-auto rounded-lg mb-2 items-center',
        )
      }
      bodyClassName="p-4"
      {...customDefaultConfig}
      {...props}
    />
  );
};

export default ToastContainer;
